import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { pieceQrLanding } from "../../services/studioSalesApi";
import { rememberReturnTo, studioPiecePath } from "./internalQr";

const readAuth = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "null");
  } catch {
    return null;
  }
};

const StudioPieceQrPage = () => {
  const { productId } = useParams<{ productId: string }>();
  const history = useHistory();
  const [error, setError] = useState("");

  useEffect(() => {
    const uid = decodeURIComponent(String(productId || "").trim());
    if (!uid) {
      setError("Missing product");
      return;
    }
    let cancelled = false;
    pieceQrLanding(uid)
      .then((res: any) => {
        if (cancelled) {
          return;
        }
        const landing = String(res?.data?.landing || "");
        if (landing === "CERT") {
          if (readAuth()) {
            history.replace(`/sales/credit/new?add=${encodeURIComponent(uid)}`);
            return;
          }
          history.replace(`/product-verifing/${encodeURIComponent(uid)}`);
          return;
        }
        if (landing === "NOT_FOUND" || !res?.success) {
          setError(landing === "NOT_FOUND" ? "Product not found" : res?.message || "Product not found");
          return;
        }
        if (readAuth()) {
          history.replace(`/sales/memos/new?add=${encodeURIComponent(uid)}`);
          return;
        }
        rememberReturnTo(studioPiecePath(uid));
        history.replace("/login");
      })
      .catch(() => {
        if (!cancelled) {
          setError("Could not open this QR");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [history, productId]);

  if (error) {
    return (
      <div className="gi-registry-page" style={{ padding: 24 }}>
        <p>{error}</p>
      </div>
    );
  }
  return (
    <div className="gi-registry-page" style={{ padding: 24 }}>
      <p>Opening piece…</p>
    </div>
  );
};

export default StudioPieceQrPage;
